import { SocketProviderConfig } from '@aibees/shared/definition';
import { Centrifuge } from 'centrifuge';
import { PropsWithChildren } from 'react';

export interface SocketProviderProps
  extends SocketProviderConfig,
    PropsWithChildren {}

export interface SocketContextData {
  url?: string;
  socket?: Centrifuge;
}

export interface GetTokenApiResponse {
  token: string;
}

export enum SocketMessageType {
  PERSON_CHANGES = 'PERSON_CHANGES',
  COMPANY_CHANGES = 'COMPANY_CHANGES',
  NOTIFICATION_COUNT = 'NOTIFICATION_COUNT',
  BALANCE = 'BALANCE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  EXPORT_ADD = 'EXPORT_ADD',
  EXPORT_UPDATE = 'EXPORT_UPDATE',
  EXPORT_INTEGRATION_UPDATE = 'EXPORT_INTEGRATION_UPDATE',
  LABEL_UPDATE = 'LABEL_UPDATE',
  CRAWL_UPDATE = 'CRAWL_UPDATE',
}
